<template>
    <div class="clearfix company-form-container bg-transparent no-shadow reports-tab-nav rounded mt-4 pb-5 mx-auto px-3 template-wrapper employee-table-wrapper"> <!-- Mustafijur Removed: class="bg-transparent no-shadow reports-tab-nav " 09-04-2026  -->

        <div class="clearfix row py-2 mb-2">
           <div class="col-sm-3 px-3 company-form-box-title">Templates</div>
        </div>

        <div v-for="category in categories" :key="category.value" >

            <template v-if="category.value == 1 || category.value == 2">
                <div  class="mb-4 pb-4">
                    <div class="clearfix row py-2 mb-2">
                        <div class="col-sm-3 px-3 company-form-box-title">{{category.text}} </div>
                    </div>

                    <template v-if="category.value == 1 || category.value == 2">

                            <div class="col-sm-12  px-0">
                                <b-overlay :show="showoverlay_list" rounded="sm">
                                    <table class="table list-tables" :id="category.value" :per-page="perPage" :current-page="currentPage">
                                        <thead>
                                            <tr class="table-head">
                                                  <!-- alpha fix- removed class pl-5  -->
                                                <td class="">#</td>
                                                <td>Template Title</td>
                                                <td>Authorized Signatory</td>

                                                <td v-if="ce" >Action</td> <!-- Mustafijur Removed: class="float-right" 09-04-2026  -->

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="hover-bg table-row border-bottom mx-2" v-for="(template , n) in templates[category.value]" :key="template.id" >
                                                <td class="col-md-1 align-middle list-columns pl-5">{{n + 1}}</td>
                                                <td class="col-md-5 align-middle list-columns">
                                                    <div class="">{{template.title}}
                                                        <span class="badge-pill m-3 green-bg" v-if="template.company_id == 0">Default</span>
                                                        <b-icon icon="check-circle-fill" variant="success" aria-hidden="true" v-if="(defaults[template.category][template.type]==template.id)"></b-icon>

                                                    </div>

                                                </td>
                                                <td class="col-md-2 align-middle list-columns" >
                                                    <div v-if="template.company_id == 0" style="font-size:14px;">
                                                        <template v-if="default_templates[template.id]">
                                                            {{default_signatories[default_templates[template.id].signature_id]}}
                                                        </template>
                                                        <template v-else>

                                                        </template>


                                                    </div>
                                                    <div style="font-size:14px;" v-if="template.company_id != 0">{{default_signatories[template.signature_id]}}</div>
                                                </td>



                                                <td class="clearfix col-md-4 align-middle" v-if="ce">
                                                    <div class="float-right mr-2 position-relative">
                                                        <b-button-toolbar>
                                                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown" style="width:230px">
                                                                 <b-button-group class="mr-1">
                                                                    <b-button class="" variant="outline-secondary" title="Download Sample Details" @click="download_sample(template.id, template.is_noc)"> <!-- Mustafijur Added: variant="outline-secondary" and removed rounded delete-btn on 12-04-2026 --> <!--Afrin: added for is_noc -->
                                                                        <b-icon icon="cloud-download" class="mr-2" aria-hidden="true"></b-icon>Download Sample
                                                                    </b-button>

                                                                    <template  v-if="$acl['templates/list'] > 1">
                                                                        <b-button class="" variant="outline-secondary" title="Preview Details" @click="previewTemplate(template.id, template.is_noc)"> <!-- Mustafijur Added: variant="outline-secondary" and removed rounded delete-btn on 12-04-2026 --> <!--Afrin: added for is_noc -->
                                                                            <i class="fas fa-list"> </i>Preview
                                                                        </b-button>
                                                                    </template>


                                                                    <template  v-if="$acl['templates/list'] > 1">

                                                                        <template v-if="template.company_id == 0">


                                                                            <b-button class="" variant="outline-secondary" title="Add/Edit Signatory" @click="addSignatory(template.id, template.is_noc)"> <!-- Mustafijur Added: variant="outline-secondary" and removed rounded delete-btn on 12-04-2026 --> <!--Afrin: added for is_noc -->
                                                                                <b-icon icon="clipboard-plus" class="mr-2" aria-hidden="true"></b-icon>Add/Edit Signatory
                                                                            </b-button>

                                                                            <b-button class="" variant="outline-secondary" title="Duplicate Template Details" @click="duplicate_template(template.id, template.is_noc)"> <!-- Mustafijur Added: variant="outline-secondary" and removed rounded delete-btn on 12-04-2026 --> <!--Afrin: added for is_noc -->
                                                                                <b-icon icon="clipboard-plus" class="mr-2" aria-hidden="true"></b-icon>Duplicate
                                                                            </b-button>

                                                                            <template v-if=" (defaults[template.category][template.type]==template.id)" >
                                                                                <b-button class="" variant="outline-secondary" title="This Template is Active" > <!-- Mustafijur Added: variant="outline-secondary" and removed rounded delete-btn on 12-04-2026 -->
                                                                                    <b-icon icon="check-circle-fill" variant="success" aria-hidden="true" ></b-icon>Active Template
                                                                                </b-button>
                                                                            </template>
                                                                            <template v-else>
                                                                                <b-button class="" variant="outline-secondary" title="Make This Template Active" @click="make_default(template.id, template.is_noc)"> <!-- Mustafijur Added: variant="outline-secondary" and removed rounded delete-btn on 12-04-2026 --> <!--Afrin: added for is_noc -->
                                                                                <b-icon icon="arrow-right-circle" class="mr-2" aria-hidden="true"></b-icon>Make Active
                                                                            </b-button>
                                                                            </template>
                                                                        </template>


                                                                        <template v-else>
                                                                            <!-- AbdullahFixed added varient and removed class="mr-3 rounded edit-btn"  -->
                                                                            <b-button variant="outline-secondary" title="Edit Template Details" @click="editTemplate(template.id,1, template.is_noc)"><!--Afrin: added for is_noc -->
                                                                                <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                                            </b-button>
                                                                            <!-- AbdullahFixed added varient and removed class="rounded delete-btn"  -->
                                                                            <b-button variant="outline-secondary" title="Delete Template Details" @click="deleteTemplate(template.id, template.is_noc)"><!--Afrin: added for is_noc -->
                                                                                <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                                            </b-button>

                                                                            <template v-if=" (defaults[template.category][template.type]==template.id)" >
                                                                                <!-- AbdullahFixed added varient and removed class="rounded delete-btn"  -->
                                                                                <b-button variant="outline-secondary" title="This Template is Active" >
                                                                                <b-icon icon="check-circle-fill" variant="success" aria-hidden="true" ></b-icon>Active Template
                                                                            </b-button>
                                                                            </template>
                                                                            <template v-else>
                                                                                <!-- AbdullahFixed added varient and removed class="rounded delete-btn"  -->
                                                                                <b-button variant="outline-secondary" title="Make This Template Active" @click="make_default(template.id, template.is_noc)"><!--Afrin: added for is_noc -->
                                                                                <b-icon icon="arrow-right-circle" class="mr-2" aria-hidden="true"></b-icon>Make Active
                                                                            </b-button>
                                                                            </template>

                                                                        </template>
                                                                    </template>



                                                                </b-button-group>
                                                            </div>
                                                        </b-button-toolbar>
                                                    </div>
                                                </td>
                                            </tr>





                                        </tbody>
                                    </table>
                                <!--<div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                                    <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav></div>-->

                                </b-overlay>
                            </div>
                    </template>

                </div>

            </template>
            <template v-if="category.value == 3 || category.value == 4 || category.value == 9">
                <div  class="mb-4 pb-4">

                    <div class="clearfix row py-2 mb-2">
                        <div class="col-sm-12 px-3 company-form-box-title">{{category.text}} </div>
                        <!-- <div class="col-sm-9 float-right text-right pr-0">

                            <b-button id="show-btn" class="mr-3" v-if="ce" @click="addNew(category.value)"><b-icon icon="plus" ></b-icon>Add New {{category.text}}</b-button>
                        </div> -->
                    </div>

                    <template v-if="category.value == 3 || category.value == 4 || category.value == 9">


                        <template v-for="sub_cat in category.sub_category" >

                            <div class="clearfix row py-2 mb-2">
                                <div class="col-sm-12 px-12 company-form-box-title">{{sub_cat.text}} </div>

                            </div>

                            <div class="col-sm-12  px-0">
                                <b-overlay :show="showoverlay_list" rounded="sm">
                                    <table class="table list-tables" :id="category.value" :per-page="perPage" :current-page="currentPage">
                                        <thead>
                                            <tr class="table-head">
                                                  <!-- alpha fix- removed class pl-5  -->
                                                <td class="">#</td>
                                                <td>Template Title</td>
                                                <td>Authorized Signatory </td>

                                                <td v-if="ce">Action</td> <!-- Mustafijur Removed: class="float-right" 09-04-2026  -->

                                            </tr>
                                        </thead>
                                        <tbody>

                                            <!-- Abdullah Fixed here in the 1st v-for. was in templates[category.value] -->
                                            <tr class="hover-bg table-row border-bottom mx-2" v-for="(template , n)  in templates[category.value]" :key="template.id" v-if="sub_cat.value == template.type">
                                                <td class="col-md-1 align-middle list-columns pl-5">{{n + 1}}</td>
                                                <td class="col-md-5 align-middle list-columns">
                                                    <div class="">{{template.title}}
                                                        <span class="badge-pill m-3 green-bg" v-if="template.company_id == 0">Default</span>
                                                        <b-icon icon="check-circle-fill" variant="success" aria-hidden="true" v-if=" (defaults[template.category][template.type]==template.id)"></b-icon>


                                                    </div>

                                                </td>
                                                <td class="col-md-2 align-middle list-columns" >
                                                    <div v-if="template.company_id == 0" style="font-size:14px;">
                                                        <template v-if="default_templates[template.id]">
                                                            {{default_signatories[default_templates[template.id].signature_id]}}
                                                        </template>
                                                        <template v-else>

                                                        </template>
                                                    </div>
                                                    <div style="font-size:14px;" v-if="template.company_id != 0">{{default_signatories[template.signature_id]}}</div>
                                                </td>



                                                <td class="clearfix col-md-4 align-middle" v-if="ce">
                                                    <div class="float-right mr-2 position-relative">
                                                        <b-button-toolbar>
                                                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown" style="width:230px">
                                                                 <b-button-group class="mr-1">
                                                                    <b-button class="" variant="outline-secondary" title="Download Sample Details" @click="download_sample(template.id, template.is_noc)"> <!-- Mustafijur Added: variant="outline-secondary" and removed rounded delete-btn on 12-04-2026 --><!--Afrin: added for is_noc -->
                                                                        <b-icon icon="cloud-download" class="mr-2" aria-hidden="true"></b-icon>Download Sample
                                                                    </b-button>
                                                                    <template  v-if="$acl['templates/list'] > 1">
                                                                        <b-button class="" variant="outline-secondary" title="Preview Details" @click="previewTemplate(template.id, template.is_noc)"> <!-- Mustafijur Added: variant="outline-secondary" and removed rounded delete-btn on 12-04-2026 --><!--Afrin: added for is_noc -->
                                                                            <i class="fas fa-list"> </i>Preview
                                                                        </b-button>
                                                                    </template>
                                                                    <template  v-if="$acl['templates/list'] > 1">

                                                                        <template v-if="template.company_id == 0">

                                                                            <b-button class="" variant="outline-secondary" title="Add/Edit Signatory" @click="addSignatory(template.id, template.is_noc)"> <!-- Mustafijur Added: variant="outline-secondary" and removed rounded delete-btn on 12-04-2026 --><!--Afrin: added for is_noc -->
                                                                                <b-icon icon="clipboard-plus" class="mr-2" aria-hidden="true"></b-icon>Add/Edit Signatory
                                                                            </b-button>

                                                                            <b-button class="" variant="outline-secondary" title="Duplicate Template Details" @click="duplicate_template(template.id, template.is_noc)"> <!-- Mustafijur Added: variant="outline-secondary" and removed rounded delete-btn on 12-04-2026 --><!--Afrin: added for is_noc -->
                                                                                <b-icon icon="clipboard-plus" class="mr-2" aria-hidden="true"></b-icon>Duplicate
                                                                            </b-button>

                                                                            <template v-if=" (defaults[template.category][template.type]==template.id)" >
                                                                                <b-button class="" variant="outline-secondary" title="This Template is Active" > <!-- Mustafijur Added: variant="outline-secondary" and removed rounded delete-btn on 12-04-2026 -->
                                                                                    <b-icon icon="check-circle-fill" variant="success" aria-hidden="true" ></b-icon>Active Template
                                                                                </b-button>
                                                                            </template>
                                                                            <template v-else>
                                                                                <b-button class="" variant="outline-secondary" title="Make This Template Active" @click="make_default(template.id, template.is_noc)"> <!-- Mustafijur Added: variant="outline-secondary" and removed rounded delete-btn on 12-04-2026 --><!--Afrin: added for is_noc -->
                                                                                    <b-icon icon="arrow-right-circle" class="mr-2" aria-hidden="true"></b-icon>Make Active
                                                                                </b-button>
                                                                            </template>

                                                                        </template>
                                                                        <template v-else>
                                                                            <!-- AbdullahFixed added varient and removed class="mr-3 rounded edit-btn"  -->
                                                                            <b-button variant="outline-secondary"  title="Edit Template Details" @click="editTemplate(template.id,1, template.is_noc)"><!--Afrin: added for is_noc -->
                                                                                <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                                            </b-button>
                                                                            <!-- AbdullahFixed added varient and removed class="rounded delete-btn"   -->
                                                                            <b-button variant="outline-secondary"  title="Delete Template Details" @click="deleteTemplate(template.id, template.is_noc)"><!--Afrin: added for is_noc -->
                                                                                <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                                            </b-button>

                                                                            <template v-if=" (defaults[template.category][template.type]==template.id)" >
                                                                                <!-- AbdullahFixed added varient and removed class="rounded delete-btn"   -->
                                                                                    <b-button variant="outline-secondary"  title="This Template is Active" >
                                                                                    <b-icon icon="check-circle-fill" variant="success" aria-hidden="true" ></b-icon>Active Template
                                                                                    </b-button>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <!-- AbdullahFixed added varient and removed class="rounded delete-btn"   -->
                                                                                    <b-button variant="outline-secondary"  title="Make This Template Active" @click="make_default(template.id, template.is_noc)"><!--Afrin: added for is_noc -->
                                                                                    <b-icon icon="arrow-right-circle" class="mr-2" aria-hidden="true"></b-icon>Make Active
                                                                                </b-button>
                                                                            </template>

                                                                        </template>
                                                                    </template>



                                                                </b-button-group>
                                                            </div>
                                                        </b-button-toolbar>
                                                    </div>
                                                </td>
                                            </tr>





                                        </tbody>
                                    </table>
                                <!--<div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                                    <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav></div>-->

                                </b-overlay>
                            </div>

                        </template>


                    </template>

                    <template v-else>
                        <div class="col-sm-12  px-0">
                        <b-overlay :show="showoverlay_list" rounded="sm">
                            <table class="table list-tables" :id="category.value" :per-page="perPage" :current-page="currentPage">
                                <thead>
                                    <tr class="table-head">
                                          <!-- alpha fix- removed class pl-5  -->
                                        <td class="col-md-1">#</td>
                                        <td lass=" col-md-5">Template Title</td>
                                        <td lass=" col-md-2">Authorized Signatory</td>
                                        <td lass=" col-md-4 float-right" v-if="ce" >Action</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="hover-bg table-row border-bottom mx-2" v-for="(template , n) in templates[category.value]" :key="template.id" >
                                        <td class="col-md-1 align-middle list-columns pl-5">{{n + 1}}</td>
                                        <td class="col-md-5 align-middle list-columns">
                                            <div class="">{{template.title}}
                                                <span class="badge-pill m-3 green-bg" v-if="template.company_id == 0">Default</span>
                                                <b-icon icon="check-circle-fill" variant="success" aria-hidden="true" v-if="(defaults[template.category][template.type]==template.id)"></b-icon>

                                            </div>

                                        </td>
                                        <td class="col-md-2 align-middle list-columns" >
                                            <div v-if="template.company_id == 0" style="font-size:14px;">

                                                <template v-if="default_templates[template.id]">
                                                    {{default_signatories[default_templates[template.id].signature_id]}}
                                                </template>
                                                <template v-else>

                                                </template>
                                            </div>
                                            <div  v-if="template.company_id != 0" style="font-size:14px;">{{default_signatories[template.signature_id]}}</div>

                                    </td>


                                        <td class="clearfix col-md-6 align-middle" v-if="ce">
                                            <div class="float-right mr-2 position-relative">
                                                <b-button-toolbar>
                                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown" style="width:230px">
                                                        <b-button-group class="mr-1">
                                                            <b-button class="rounded delete-btn" title="Download Sample Details" @click="download_sample(template.id)">
                                                                <b-icon icon="cloud-download" class="mr-2" aria-hidden="true"></b-icon>Download Sample
                                                            </b-button>
                                                            <template  v-if="$acl['templates/list'] > 1">
                                                                <b-button class="rounded delete-btn" title="Preview Details" @click="previewTemplate(template.id)">
                                                                    <i class="fas fa-list"> </i>Preview
                                                                </b-button>
                                                            </template>
                                                            <template  v-if="$acl['templates/list'] > 1">
                                                                <template v-if="template.company_id == 0">


                                                                    <b-button class="rounded delete-btn" title="Duplicate Template Details" @click="duplicate_template(template.id)">
                                                                        <b-icon icon="clipboard-plus" class="mr-2" aria-hidden="true"></b-icon>Duplicate
                                                                    </b-button>

                                                                    <b-button class="rounded delete-btn" title="Add/Edit Signatory" @click="addSignatory(template.id)">
                                                                        <b-icon icon="clipboard-plus" class="mr-2" aria-hidden="true"></b-icon>Add/Edit Signatory
                                                                    </b-button>

                                                                    <template v-if=" (defaults[template.category][template.type]==template.id)" >
                                                                            <b-button class="rounded delete-btn" title="This Template is Active" >
                                                                            <b-icon icon="check-circle-fill" variant="success" aria-hidden="true" ></b-icon>Active Template
                                                                            </b-button>
                                                                        </template>
                                                                        <template v-else>
                                                                            <b-button class="rounded delete-btn" title="Make This Template Active" @click="make_default(template.id)">
                                                                            <b-icon icon="arrow-right-circle" class="mr-2" aria-hidden="true"></b-icon>Make Active
                                                                        </b-button>
                                                                    </template>

                                                                </template>
                                                                <template v-else>
                                                                    <!-- AbdullahFixed added varient and removed class="mr-3 rounded edit-btn"    -->
                                                                    <b-button variant="outline-secondary" title="Edit Template Details" @click="editTemplate(template.id,1)">
                                                                        <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                                    </b-button>
                                                                    <!-- AbdullahFixed added varient and removed class="rounded delete-btn"    -->
                                                                    <b-button variant="outline-secondary" itle="Delete Template Details" @click="deleteTemplate(template.id)">
                                                                        <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                                    </b-button>

                                                                    <template v-if=" (defaults[template.category][template.type]==template.id)" >
                                                                        <!-- AbdullahFixed added varient and removed  class="rounded delete-btn"   -->
                                                                        <b-button variant="outline-secondary" title="This Template is Active" >
                                                                        <b-icon icon="check-circle-fill" variant="success" aria-hidden="true" ></b-icon>Active Template
                                                                        </b-button>
                                                                    </template>
                                                                    <template v-else>
                                                                        <!-- AbdullahFixed added varient and removed  class="rounded delete-btn"   -->
                                                                        <b-button variant="outline-secondary" title="Make This Template Active" @click="make_default(template.id)">
                                                                        <b-icon icon="arrow-right-circle" class="mr-2" aria-hidden="true"></b-icon>Make Active
                                                                    </b-button>
                                                                    </template>

                                                                </template>

                                                            </template>

                                                        </b-button-group>
                                                    </div>
                                                </b-button-toolbar>
                                            </div>
                                        </td>
                                    </tr>





                                </tbody>
                            </table>
                        <!--<div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                            <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav></div>-->
                        </b-overlay>
                    </div>
                    </template>
                </div>
            </template>
        </div>


        <div class="row justify-content-center">

            <!-- template add/edit form -->
            <div class="col-sm-12  px-0" v-if="this.ce">
                <b-modal id="bv-modal-template" dialog-class="modal-xml" size="lg" hide-footer >
                    <template #modal-title>
                        <div v-for="category in categories" :key="category.value">
                            <template v-if="category.value==fdata.category">
                                Template Details ({{category.text}})
                            </template>
                        </div>
                    </template>
                    <b-overlay :show="showoverlay" rounded="sm">
                        <b-form @submit.stop.prevent="onSubmit" class="">
                            <input type="hidden" v-model="fdata.id" name="id">
                            <div class="clearfix">

                                <b-form-group id="name-group" label="Name" class="required-field" label-for="name">
                                    <b-form-input id="name" name="name" v-model="fdata.title" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name" :readonly="default_edit == 0"></b-form-input>
                                    <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                </b-form-group>

                                <template v-if= "fdata.category == 1 ||fdata.category == 2 || fdata.category == 3 || fdata.category == 4 || fdata.category == 9">
                                     <b-form-group id="type-group" label="Type" label-for="type">
                                       <b-form-select id="type" name="type" v-model="fdata.type" v-validate="{ required:false }" v-if= "fdata.category == 3" :options="hr_cirtificate" :state="validateState('type')" aria-describedby="type-feedback" data-vv-as="Type"></b-form-select>
                                       <b-form-select id="type" name="type" v-model="fdata.type" v-validate="{ required:false }" v-if= "fdata.category == 4" :options="leaver_certificate" :state="validateState('type')" aria-describedby="type-feedback" data-vv-as="Type"></b-form-select>
                                       <b-form-select id="type" name="type" v-model="fdata.type" v-validate="{ required:false }" v-if= "fdata.category == 1" :options="employment_contract" :state="validateState('type')" aria-describedby="type-feedback" data-vv-as="Type"></b-form-select>
                                       <b-form-select id="type" name="type" v-model="fdata.type" v-validate="{ required:false }" v-if= "fdata.category == 2" :options="contract_ammendment" :state="validateState('type')" aria-describedby="type-feedback" data-vv-as="Type"></b-form-select>

                                       <b-form-select id="type" name="type" v-model="fdata.type" v-validate="{ required:false }" v-if= "fdata.category == 9" :options="compliance_cirtificate" :state="validateState('type')" aria-describedby="type-feedback" data-vv-as="Type"></b-form-select>


                                       <b-form-invalid-feedback id="type-feedback">{{ veeErrors.first('sub_category_id') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </template>

                                 <b-form-group id="signatory-group" label="Company Signatory" label-for="signatory">
                                     <b-form-select id="type" name="type" v-model="fdata.signature" v-validate="{ required:false }" :options="signatures" :state="validateState('type')" aria-describedby="type-feedback" data-vv-as="Type"></b-form-select>
                                    <!-- <b-form-select id="signatory" name="signatory" v-model="fdata.signature" :options="signatures"  :state="validateState('signatory')" aria-describedby="signatory-feedback" data-vv-as="Signatory"></b-form-select> -->

                                </b-form-group>
                                <template v-if="default_edit == 0">
                                    <ckeditor @namespaceloaded="onNamespaceLoaded" :config="editorConfig_default" v-model="fdata.content" ></ckeditor>
                                </template>
                                <template v-else>
                                    <ckeditor @namespaceloaded="onNamespaceLoaded" :config="editorConfig" v-model="fdata.content" ></ckeditor>
                                </template>

                                <div class="mt-3">

                                    <template v-if="fdata.id > 0">
                                        <b-button type="submit" @click="duplicate(0)" variant="primary" style=""><b-icon variant="light" icon="pencil" scale="1" width="20px" height="20px" class="align-left mr-2"></b-icon>Save Template</b-button>
                                        <b-button type="submit" @click="duplicate(1)" variant="primary" style=""><b-icon variant="light" icon="clipboard-plus" scale="1" width="20px" height="20px" class="align-left mr-2"></b-icon>Duplicate Template</b-button>
                                    </template>
                                    <template v-else>
                                        <b-button type="submit" variant="primary" style=""><b-icon variant="light" icon="plus-circle" scale="1" width="20px" height="20px" class="align-left mr-2"></b-icon>Add Template</b-button>
                                    </template>

                                </div>
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>


            <!-- add signatory to default template form -->

            <b-modal id="bv-modal-signatory-add" dialog-class="modal-xml" size="lg" hide-footer >
                    <template #modal-title>
                        <div v-for="category in categories" :key="category.value">
                            <template v-if="category.value==fdata.category">
                                Add Signatory to Default Template ({{fdata.title}} )
                            </template>
                        </div>
                    </template>
                    <b-overlay :show="showoverlay" rounded="sm">

                        <b-form @submit.stop.prevent="onSubmitSignatory" class="">
                            <input type="hidden" v-model="fdata.id" name="id">
                            <div class="clearfix">

                                 <b-form-group id="signatory-group" label="Company Signatory" label-for="signatory">
                                     <b-form-select id="type" name="type" v-model="fdata.signature" v-validate="{ required:false }" :options="signatures" :state="validateState('type')" aria-describedby="type-feedback" data-vv-as="Type"></b-form-select>
                                </b-form-group>
                                <div class="mt-3">
                                    <template v-if="fdata.id > 0">
                                        <b-button type="submit" @click="duplicate(0)" variant="primary" style=""><b-icon variant="light" icon="pencil" scale="1" width="20px" height="20px" class="align-left mr-2"></b-icon>Save Template</b-button>
                                    </template>
                                </div>
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>

            <!-- add signatory to default template form end -->

            <!-- template preview form -->


                <b-modal id="bv-modal-template-preview" dialog-class="modal-xml" size="lg" hide-footer >
                    <template #modal-title>
                        <div v-for="category in categories" :key="category.value">
                            <template v-if="category.value==fdata.category">
                                Template Details ({{category.text}})
                            </template>
                        </div>
                    </template>
                    <b-overlay :show="showoverlay" rounded="sm">
                        <b-form @submit.stop.prevent="onSubmit" class="">
                            <input type="hidden" v-model="fdata.id" name="id">


                            <div class="clearfix">

                                <b-form-group id="name-group" label="Name" class="required-field" label-for="name">
                                    <b-form-input id="name" name="name" v-model="fdata.title" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"  ></b-form-input>
                                    <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                </b-form-group>

                                <input type="hidden" id="type" name="type"  v-model="fdata.type">

                                <b-form-group id="signatory-group" label="Company Signatory" label-for="signatory">
                                    <b-form-select id="signatory" name="signatory" v-model="fdata.signature" :options="signatures"  :state="validateState('signatory')" aria-describedby="signatory-feedback" data-vv-as="Signatory"></b-form-select>

                                </b-form-group>

                                <ckeditor @namespaceloaded="onNamespaceLoaded" :config="editorConfig_default" v-model="fdata.content"></ckeditor>
                                <div class="mt-3">
                                    <b-button type="submit" @click="duplicate(1)" variant="primary" style=""><b-icon variant="light" icon="clipboard-plus" scale="1" width="20px" height="20px" class="align-left mr-2"></b-icon>Duplicate Template</b-button>


                                </div>

                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>
            </div>







        </div>

    </div>
</template>
<script>

    export default{

        mounted() {
            if(this.check_ce == 1)
            {
                if(this.ce_flg == 1)
                    this.ce = true;
                else
                    this.ce = false;
            }
        },
        props: ['ce_flg' , 'check_ce'],
        data(){

            return {

                editorConfig: {
                    extraPlugins: ['placeholder_select' , 'justify'],
                    //extraPlugins: 'strinsert',
                    placeholder_select:{
                        placeholders: [],
                        format:' [[%placeholder%]] ',
                    },
                    allowedContent : true,
                    /*stylesSet: 'my_styles',*/

                },

                editorConfig_default: {
                    extraPlugins: ['placeholder_select' , 'justify'],
                    //extraPlugins: 'strinsert',
                    placeholder_select:{
                        placeholders: [],
                        format:' [[%placeholder%]] ',
                    },
                    readOnly : true, //aboni

                },


                default_templates:[],
                templates:[],
                placeholder : [],

                successmsg:false,
                warningmsg:false,
                dangermsg:false,

                showoverlay:false,
                showoverlay_list:false,
                movenext : false,

                errormsg:[],
                fdata: { id:null , title:'' , category:0 , type:0 , content:'' , duplicate:0, signature:0},
                signature_fdata:{},

                search:'',
                length: 3,

                ce : true,

                content : '',

                pagination: {currentPage: 1, pages:1},
                perPage: 3,
                currentPage: 1,
                defaults:[],

                download_loader : '',
                download_text : '',
                //27-11-21 starts
                signatories: [],
                signatures:  [
                    {value: '0', text: "Select..."},
                ],
                default_signatories:[],
                //27-11-21 ends
                default_edit :1,


                categories: [

                    { value: "1", text: "Employment Contract" , sub_category:[]},
                    { value: "2", text: "Contract Change Letter" , sub_category:[]},
                    { value: "3", text: "HR Certificates" , sub_category:[
                        {value: '1', text: "Standard Salary Certificate (Current Salary)"},
                        {value: '2', text: "Standard Salary Certificate (Period Range)"},
                        {value: '3', text: "Letter of Introduction"},
                        {value: '4', text: "Increament Letter"},
                        { value: '7', text: "No Objection Certificate (NOC)-Travel" },  // Afrin: added for noc
                        { value: '8', text: "No Objection Certificate (NOC)-General" },  // Afrin: added for noc
                    ]},
                    { value: "4", text: "Leaver Certificates" , sub_category:[
                        {value: '1', text: "Release Letter"},
                        {value: '2', text: "Experience Certificate"},
                        {value: '3', text: "Recommendation Letter"},
                        // Afrin: Added for Template sub-category start
                        {value: '4', text: "Acceptance of Resignation"},
                        {value: '5', text: "Termination Letter"},
                        // Afrin: Added for Template sub-category end

                    ]},
                    { value: "9", text: "Compliance Certificates" , sub_category:[
                        {value: '5', text: "Income Tax Deduction Certificate"},
                        {value: '6', text: "Investment Declaration Letter"},
                    ]},

                   /*{ value: "5", text: "HR Policies & Handbooks", sub_category:[] },
                    { value: "6", text: "Others" , sub_category:[]},*/
                ],
                employment_contract:
                [
                    {value: '0', text: "Select..."},
                    {value: '1', text: "Employment Contract"},
                ],
                contract_ammendment:
                [
                    {value: '0', text: "Select..."},
                    {value: '1', text: "Contract Change Letter"},
                ],
                hr_cirtificate:
                [
                    {value: '0', text: "Select..."},
                    {value: '1', text: "Standard Salary Certificate (Current Salary)"},
                    {value: '2', text: "Standard Salary Certificate (Period Range)"},
                    {value: '3', text: "Letter of Introduction"},
                    {value: '4', text: "Increament Letter"},,
                    { value: '7', text: "No Objection Certificate (NOC)-Travel" },  // Afrin: added for noc
                    { value: '8', text: "No Objection Certificate (NOC)-General" },  // Afrin: added for noc
                ],

                compliance_cirtificate:
                [
                    {value: '0', text: "Select..."},
                    {value: '5', text: "Income Tax Deduction Certificate"},
                    {value: '6', text: "Investment Declaration Letter"},
                ],

                leaver_certificate:
                [
                    {value: '0', text: "Select..."},
                    {value: '1', text: "Release Letter"},
                    {value: '2', text: "Experience Certificate"},
                    {value: '3', text: "Recommendation Letter"},
                    // Afrin: Added for Template sub-category start
                    {value: '4', text: "Acceptance of Resignation"},
                    {value: '5', text: "Termination Letter"},
                    // Afrin: Added for Template sub-category end
                ],

            }
        },
        methods:{
            onNamespaceLoaded( CKEDITOR ) {
                // CKEDITOR.plugins.addExternal( 'placeholder_select', '../../../../../node_modules/ckeditor4-vue/plugins/placeholder_select/', 'plugin.js' );
                 CKEDITOR.plugins.addExternal('placeholder_select', this.$api_url+'/plugin/placeholder_select/','plugin.js');
                 /* CKEDITOR.stylesSet.add( 'my_styles', [
                    // Block-level styles.
                    { name: 'Padding15', element: 'td', styles: { padding: '0 15px' } },
                    { name: 'Padding30', element: 'td', styles: { padding: '0 30px' } },

                ]);*/

            },
            addNew(x)
            {

                this.resetForm();
                this.fdata.category = x;
                this.editorConfig.placeholder_select.placeholders = this.placeholder[this.fdata.category][this.fdata.type];
                this.$bvModal.show('bv-modal-template');

            },
            getTemplateData: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/templates/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.templates = response.data;

                    this.getSignatureMappings();

                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },

            getSignatureMappings: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/templates/signature-mapping' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){

                    //console.log('Mapp');
                    //console.log(response.data);
                    var mapping_templates = [];
                    mapping_templates = response.data;
                    var signatures_arr = [];
                    signatures_arr[0] = '';

                    for(var x =0 ; x<mapping_templates.length; x++){

                    signatures_arr[mapping_templates[x].id]  = mapping_templates[x];

                    }

                    this.default_templates = signatures_arr;


                    // console.log('Default - Tse');
                    // console.log(this.default_templates);




                }.bind(this)).catch(function (error){ console.log(error)});
            },
            getTemplatePlaceholderData()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url + '/templates/placeholder' , {
                    params: {

                    }
                }).then(function(response)
                {
                    this.placeholder = response.data;
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },

            printTemplate:function(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                this.warningmsg = null;
                this.successmsg = null;


                this.showoverlay = true;
                axios.get(this.$api_url+'/templates/details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){


                    this.content = response.data.content;
                    //this.$bvModal.show('bv-modal-print');


                    this.print();

                }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
            },
            print() {
                var prtContent = document.getElementById("print");
                var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
                WinPrint.document.write(prtContent.innerHTML);
                WinPrint.document.close();
                WinPrint.focus();
                WinPrint.print();
                WinPrint.close();
            },

            editTemplate:function(x,y, is_noc = 0) // Afrin: added for is_noc
            {
                this.getSignatories();

                if(!this.checkNet()) return false;
                let currentObj = this;
                this.warningmsg = null;
                this.successmsg = null;

                this.showoverlay = true;

                this.default_edit = y;

                axios.get(this.$api_url+'/templates/details' , {
                    params: {
                        id: x,
                        is_noc: (is_noc == 1 || this.checkIfNocTemplate(x)) ? 1 : 0,  // Afrin: added for is_noc
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.fdata.signature = response.data.signature_id;
                    this.$validator.reset();
                    this.successmsg = null;
                    this.showoverlay = false;

                    this.editorConfig.placeholder_select.placeholders = this.placeholder[this.fdata.category][this.fdata.type];

                    this.$bvModal.show('bv-modal-template');

                }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});

            },
            addSignatory:function(x, is_noc = 0) // Afrin: added for is_noc
            {
                this.getSignatories();

                if(!this.checkNet()) return false;
                let currentObj = this;
                this.warningmsg = null;
                this.successmsg = null;

                this.showoverlay = true;

                axios.get(this.$api_url+'/templates/details' , {
                    params: {
                        id: x,
                        is_noc: (is_noc == 1 || this.checkIfNocTemplate(x)) ? 1 : 0,  // Afrin: added for is_noc
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.fdata.signature = this.default_templates[response.data.id].signature_id;

                    this.$validator.reset();
                    this.successmsg = null;
                    this.showoverlay = false;

                    this.editorConfig.placeholder_select.placeholders = this.placeholder[this.fdata.category][this.fdata.type];

                    this.$bvModal.show('bv-modal-signatory-add');

                }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});

            },
            previewTemplate:function(x, is_noc = 0) // Afrin: added for is_noc
            {
                this.getSignatories();

                if(!this.checkNet()) return false;
                let currentObj = this;
                this.warningmsg = null;
                this.successmsg = null;


                this.showoverlay = true;
                axios.get(this.$api_url+'/templates/details' , {
                    params: {
                        id: x,
                        is_noc: (is_noc == 1 || this.checkIfNocTemplate(x)) ? 1 : 0,  // Afrin: added for is_noc
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.fdata.signature = response.data.signature_id;
                    this.$validator.reset();
                    this.successmsg = null;
                    this.showoverlay = false;

                    this.editorConfig.placeholder_select.placeholders = this.placeholder[this.fdata.category][this.fdata.type];

                    this.$bvModal.show('bv-modal-template-preview');

                }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});

            },
            deleteTemplate(template_id, is_noc = 0) { // Afrin: added for is_noc
                    if(!this.checkNet()) return false;
                    let currentObj = this;

                    this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this template.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        this.resetForm();
                        this.warningmsg = null;
                        this.successmsg = null;

                        this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', template_id);

                        // Afrin: added for noc
                        if (is_noc == 1 || this.checkIfNocTemplate(template_id)) { // Afrin: added for is_noc
                            formData.append('is_noc', 1);
                        }
                        // Afrin: added for noc

                        axios.post(this.$api_url+'/templates/delete', formData).then(function(response){

                            if(response.data.status == true)
                            {
                                this.$bvToast.toast(response.data.meg, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                this.templates = response.data.templates;

                            }
                            else
                            {
                                this.$bvModal.msgBoxConfirm('You cannot delete an active contract.', {
                                    title: '', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Ok', footerClass: 'p-2', hideHeaderClose: false,centered: true
                                })
                                .then(value => {
                                });

                            }

                            this.resetPagination();

                            this.showoverlay_list = false;
                            this.showoverlay = false;

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.showoverlay_list = false;
                            currentObj.showoverlay = false;
                            currentObj.serverError(error);
                        });
                    }
                })
                ;
            },
            duplicate(x)
            {
                this.fdata.duplicate = x;
            },

            duplicate_template(id, is_noc = 0){ // Afrin: added for is_noc
                 axios.get(this.$api_url+'/templates/duplicate' , {
                    params: {
                        template_id: id,
                        is_noc: (is_noc == 1 || this.checkIfNocTemplate(id)) ? 1 : 0,  // Afrin: added for is_noc
                    }
                }).then(function (response)
                        {

                            this.templates = response.data;


                            this.$bvToast.toast('Saved!', {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                            this.showoverlay_list = false;
                            this.showoverlay = false;

                            this.$bvModal.hide('bv-modal-template');
                            this.$bvModal.hide('bv-modal-template-preview');

                        }.bind(this));

            },
            make_default(id, is_noc = 0){ // Afrin: added for is_noc
                 axios.get(this.$api_url+'/templates/make_default' , {
                    params: {
                        template_id: id,
                        is_noc: (is_noc == 1 || this.checkIfNocTemplate(id)) ? 1 : 0,  // Afrin: added for is_noc
                    }
                }).then(function (response)
                        {

                            this.templates = response.data;

                            this.$bvToast.toast('Saved!', {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                            this.showoverlay_list = false;
                            this.showoverlay = false;
                            this.$bvModal.hide('bv-modal-template');
                            this.$bvModal.hide('bv-modal-template-preview');

                            axios.get(this.$api_url+'/templates/get_default' , {
                    params: {

                    }
                }).then(function (response)
                        {

                            this.defaults = response.data;


                        }.bind(this))
                        .catch(function (error)
                        {
                            console.log(error);
                        });

                        }.bind(this));




            },
            download_sample(id, is_noc = 0){ // Afrin: added for is_noc
                let currentObj = this;
                 axios.get(this.$api_url+'/templates/download_sample' , {
                    params: {
                        template_id: id,
                        is_noc: (is_noc == 1 || this.checkIfNocTemplate(id)) ? 1 : 0,  // Afrin: added for is_noc
                    }
                }).then(response =>
                        {


                            var modification_flag =0;

                            var fname=response.data.file_name;

                            if(response.data.download_file_name)
                                var download_f_name =   response.data.download_file_name;
                            else
                                var download_f_name =   fname;

                            if(download_f_name){
                                window.location.href = this.$api_url+'/templates/downloadzip?file_name='+fname+'&download_file_name='+download_f_name+'&modification_flag='+modification_flag;

                            }
                          })
                          .catch(error => {

                              this.download_loader = false;
                              this.download_text = '';
                        });


            },


            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
               this.fdata = { id:null , title:'' , category:0 , type:0 , content:'' , duplicate:0, signature:0};


                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            onSubmitSignatory(e)
            {
                if(!this.checkNet()) return false;
                this.warningmsg = null;
                this.successmsg = null;


                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    //this.showoverlay = true;

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);

                    }
 //aboni
                    if(formData.length>0){

                    }
                    axios.post(this.$api_url+'/templates/signatorysave', formData, config)
                        .then(function (response)
                        {
                            this.templates = response.data;

                            this.$bvToast.toast('Saved!', {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                            this.showoverlay_list = false;
                            this.showoverlay = false;
                            //this.resetForm();
                            //this.movenext = true;

                            this.$bvModal.hide('bv-modal-signatory-add');
                            this.$bvModal.hide('bv-modal-template-preview');
                            this.getTemplatePlaceholderData();
                            this.getTemplateData();
                            this.get_default();
                            this.getSignatories();

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.showoverlay_list = false;
                            currentObj.showoverlay = false;

                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                        });
                });
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.warningmsg = null;
                this.successmsg = null;


                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    //this.showoverlay = true;

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);

                    }

                    if(formData.length>0){

                    }
                    axios.post(this.$api_url+'/templates/save', formData, config)
                        .then(function (response)
                        {
                            this.templates = response.data;

                            this.$bvToast.toast('Saved!', {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                            this.showoverlay_list = false;
                            this.showoverlay = false;
                            //this.resetForm();
                            //this.movenext = true;

                            this.$bvModal.hide('bv-modal-template');
                            this.$bvModal.hide('bv-modal-template-preview');


                            this.getTemplatePlaceholderData();
                            this.getTemplateData();
                            this.get_default();
                            this.getSignatories();

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.showoverlay_list = false;
                            currentObj.showoverlay = false;

                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                        });
                });
            },

            get_default(){
                axios.get(this.$api_url+'/templates/get_default' , {
                    params: {

                    }
                }).then(function (response)
                        {
                            this.defaults = response.data;
                        }.bind(this))
                        .catch(function (error)
                        {

                        });
                        //this.$forceUpdate();



            },

            getSignatories: function() //27-12-21
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/signatory' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.signatories = response.data;
                    var signatures = [];
                    var signatures_arr = [];
                    var tempObj = {value: '0', text: "Select..."};
                    signatures_arr[0] = '';
                     signatures.push(tempObj);

                    for(var x =0 ; x<this.signatories.length; x++){
                        var tempObj = {};
                        signatures_arr[this.signatories[x].id]  = this.signatories[x].name + " - " + this.signatories[x].designation;
                        tempObj['value'] = this.signatories[x].id;
                        tempObj['text'] = this.signatories[x].name + " - " + this.signatories[x].designation;
                        signatures.push(tempObj);
                    }

                    this.default_signatories = signatures_arr;
                    this.signatures = signatures;



                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },

            // Afrin: added for is_noc start
            checkIfNocTemplate(id) {
                if (typeof id == 'object' && id !== null) {
                    return id.is_noc == 1;
                }
                return false;
            },
            // Afrin: added for is_noc end

        },
        created: function(){
            this.getTemplatePlaceholderData();
            this.getTemplateData();
            this.get_default();
            this.getSignatories();


        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.templates['3']; //templates[category.value];

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
            rows()
            {
                return this.templates['3'].length;
            }
        }
    }


</script>
